import { FC, SyntheticEvent, useState } from 'react';
import { useMutation } from '@apollo/client';
import Dialog from 'components/common/Dialog/Dialog';
import ELEMENT from 'common/element';
import ResizableTextArea from 'components/common/Input/ResizableTextArea';
import { REQUEST_CUSTOM_PARSER } from '../queries';
import '../styles.scss';
import { ParserAndDeselect } from '../types';

type CustomParserDialogProps = {
  customParserDialogIsOpen: boolean;
  setCustomParserDialogIsOpen: (open: boolean) => void;
} & ParserAndDeselect;

/**
 *
 * A dialog that performing request for custom parser
 *
 */
const CustomParserDialog: FC<CustomParserDialogProps> = ({
  selectedParser,
  deselectParser,
  customParserDialogIsOpen,
  setCustomParserDialogIsOpen,
}: CustomParserDialogProps) => {
  const [input, setInput] = useState<string>('');
  const [requestCustomParser] = useMutation(REQUEST_CUSTOM_PARSER);

  const onDialogSubmit = (): void => {
    if (selectedParser) {
      requestCustomParser({ variables: { id: selectedParser, comments: input } });
    }
  };

  const onInputChange = (e: SyntheticEvent): void => {
    setInput((e?.target as HTMLTextAreaElement)?.value);
  };

  const onClose = (): void => {
    setCustomParserDialogIsOpen(false);
    deselectParser();
    setInput('');
  };
  return (
    <Dialog
      title="Make a parser for me"
      className="ParsersPage__Modal"
      show={customParserDialogIsOpen}
      close={onClose}
      okCallback={onDialogSubmit}
      testId={ELEMENT.customParserDialog}
    >
      <div>
        {'Click '}
        <strong>Ok</strong>
        {
          ' to send a sample of your logs to Scalyr. We’ll get back to you as soon as possible, via email, with a custom-built parser.'
        }
        <br />
        <br />
        Feel free to add comments below.
      </div>
      <br />
      <ResizableTextArea
        value={input}
        onChange={onInputChange}
        minRows={6}
        placeholder="Enter any comments or special instructions here. There is no need to paste any logs into this box; clicking Ok will automatically send us a sample of your logs."
      />
    </Dialog>
  );
};

export default CustomParserDialog;
